module.exports = __webpack_public_path__ + "img/close.5dd3486c.svg";